<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="logisticsVisible"
    :close-on-click-modal="false"
    width="600px"
    class="logistics-info-modal"
  >
    <div class="approvalStepsModal">
      <el-timeline>
        <!-- :icon="item.icon"
        :color="currentNode === index ? '#0bbd87' : ''"
          :type="item.type" -->
        <el-timeline-item
          v-for="(item, index) in logisticsList"
          :key="index"
          placement="top"
          :type="'info'"
          :color="item.color"
          :size="item.size"
          :timestamp="item.showTime"
          :class="currentNode > 1 && index === 0 ? 'lastNode' : ''"
        >
          <span v-if="item.AcceptAddress">【{{ item.AcceptAddress }}】</span>
          <span>{{ item.Remark }}</span>
        </el-timeline-item>
      </el-timeline>
      <!-- <el-steps :active="currentNode" direction="vertical" class="steps-wrap">
        <el-step
          v-for="(item, progress) in logisticsList"
          :key="progress"
          :status="item.auditStatus === '130' ? 'error' : 'finish'"
        >
          <div slot="icon">
            <span
              v-if="item.auditStatus !== '130'"
              class="successIcon"
            />
            <span v-else class="noRoadShow" />
          </div>
          <template slot="title">
            <div class="auditNode">
              <div :style="{color: item.auditStatus === '130' ? '#54abc3' : 'inherit'}">{{ item.createdName + '(' + item.createdBy +')' }}</div>
              <div class="time" :style="{color: item.auditStatus === '130' ? '#f5222d' : 'inherit'}">{{ item.createdTime ? moment(item.createdTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</div>
            </div>
          </template>
          <template slot="description">
            <div class="auditNode">
              <div class="auditDetail">
                <div class="status" :style="{color: item.auditStatus === '130' ? '#f5222d' : 'inherit'}">{{ item.desc }}</div>
              </div>
            </div>
          </template>
        </el-step>
      </el-steps> -->
    </div>
  </el-dialog>
</template>
<script>
import moment from 'moment'
import { getLogistics } from '@/api/pointsMall'
export default {
  components: {},
  props: {
    // orderId: {
    //   type: Number || String,
    // },
  },
  computed: {
  },
  data() {
    return {
      moment,
      logisticsVisible: false,
      logisticsList: [], // 物流数据
      logisticsStatus: '', // 订单发货状态
      currentOrder: {},
      dialogTitle: '物流详细信息',
    }
  },
  // watch: {
  //   orderInfo(val) {
  //     if(val) {
  //       this.getBuyerLogisticalInfo(this.orderNo)
  //     }
  //   }
  // },
  mounted() {
  },
  methods: {
    // 获取物流信息
    getLogistics(record) {
      this.currentOrder = record || {}
      this.dialogTitle = '物流详细信息' + (record.TrackingNum ? `：${record.TrackingNum}` : '')
      const params = {
        trackingNum: record.TrackingNum, // 订单id
        CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1,
      }
      getLogistics(params).then(res => {
        if (res.data) {
          this.currentNode = res.data.length || 0
          this.logisticsList = (res.data || []).map((item, index) => {
            item.color = this.currentNode > 1 && (index === 0) ? '#ff5000' : '#e4e7ed'
            item.size = this.currentNode > 1 && (index === 0) ? 'large' : 'normal'
            item.showTime = item.AcceptTime ? moment(item.AcceptTime).format('MM-DD HH:mm') : ''
            return {
              ...item
            }
          })
          this.logisticsVisible = true
        } else {
          this.$message.error(res.msg || '查询物流信息失败')
        }
      })
    },
  },
}
</script>
<style lang="less">
.logistics-info-modal {
  // 两个approvalStepsModal类都要
  .approvalStepsModal {
    .el-timeline-item__node {
      background-color: #e4e7ed;
    }
    .el-timeline-item {
      .el-timeline-item__content {
        line-height: 1.5;
      }
    }
    .el-timeline-item.lastNode {
      .el-timeline-item__timestamp {
        color: #ff5000;
      }
    }
  }
}
</style>
